(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("uikit"), require("foundation"), require("mio-core"));
	else if(typeof define === 'function' && define.amd)
		define(["uikit", "foundation", "mio-core"], factory);
	else if(typeof exports === 'object')
		exports["MUIKit"] = factory(require("uikit"), require("foundation"), require("mio-core"));
	else
		root["MUIKit"] = factory(root["uikit"], root["foundation"], root["mio-core"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_uikit__, __WEBPACK_EXTERNAL_MODULE_foundation__, __WEBPACK_EXTERNAL_MODULE_mio_core__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./sources/CustomLayers/CAComboBoxItemLayer.ts":
/*!*****************************************************!*\
  !*** ./sources/CustomLayers/CAComboBoxItemLayer.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CAComboBoxItemLayer: () => (/* binding */ CAComboBoxItemLayer)
/* harmony export */ });
/* harmony import */ var uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! uikit */ "uikit");
/* harmony import */ var uikit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(uikit__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var CAComboBoxItemLayer = /** @class */ (function (_super) {
    __extends(CAComboBoxItemLayer, _super);
    function CAComboBoxItemLayer(contents) {
        var _this = _super.call(this, contents) || this;
        _this.title = null;
        _this.value = null;
        if (contents != null) {
            _this.optionElement = (0,uikit__WEBPACK_IMPORTED_MODULE_0__._UICoreLayerGetFirstElementWithTag)(contents, "OPTION");
        }
        if (_this.optionElement == null) {
            _this.optionElement = document.createElement("OPTION");
            _this.contents.appendChild(_this.optionElement);
        }
        return _this;
    }
    CAComboBoxItemLayer.prototype.setValue = function (title, value) {
        this.title = title;
        var v = value !== null && value !== void 0 ? value : title;
        this.value = v;
        this.optionElement.innerHTML = title;
        this.optionElement.value = v;
    };
    return CAComboBoxItemLayer;
}(uikit__WEBPACK_IMPORTED_MODULE_0__.CALayer));



/***/ }),

/***/ "./sources/CustomLayers/CAComboBoxLayer.ts":
/*!*************************************************!*\
  !*** ./sources/CustomLayers/CAComboBoxLayer.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CAComboBoxLayer: () => (/* binding */ CAComboBoxLayer)
/* harmony export */ });
/* harmony import */ var uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! uikit */ "uikit");
/* harmony import */ var uikit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(uikit__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var CAComboBoxLayer = /** @class */ (function (_super) {
    __extends(CAComboBoxLayer, _super);
    function CAComboBoxLayer(contents) {
        var _this = _super.call(this, contents) || this;
        _this._on_change_target = null;
        _this._on_change_action = null;
        _this.items = [];
        if (contents != null) {
            _this.selectElement = (0,uikit__WEBPACK_IMPORTED_MODULE_0__._UICoreLayerGetFirstElementWithTag)(contents, "SELECT");
        }
        if (_this.selectElement == null) {
            _this.selectElement = document.createElement("SELECT");
            _this.contents.appendChild(_this.selectElement);
        }
        return _this;
        // TODO: Parse items
    }
    CAComboBoxLayer.prototype.setOnChangeBlock = function (target, action) {
        this._on_change_target = target;
        this._on_change_action = action;
        if (target == null) {
            this.selectElement.removeEventListener("change", this.on_change.bind(this));
        }
        else {
            this.selectElement.addEventListener("change", this.on_change.bind(this));
        }
    };
    CAComboBoxLayer.prototype.on_change = function (e) {
        if (this._on_change_action != null)
            this._on_change_action.call(this._on_change_target, uikit__WEBPACK_IMPORTED_MODULE_0__.CALayerEvent.change);
    };
    CAComboBoxLayer.prototype.addItemLayer = function (item) {
        this.items.addObject(item);
        this.selectElement.appendChild(item.optionElement);
    };
    CAComboBoxLayer.prototype.selectItem = function (value) {
        this.selectElement.value = value;
    };
    Object.defineProperty(CAComboBoxLayer.prototype, "selectedItem", {
        get: function () {
            return this.selectElement.value;
        },
        enumerable: false,
        configurable: true
    });
    CAComboBoxLayer.prototype.removeItemLayers = function () {
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var i = _a[_i];
            this.selectElement.removeChild(i.optionElement);
        }
        this.items = [];
    };
    return CAComboBoxLayer;
}(uikit__WEBPACK_IMPORTED_MODULE_0__.CALayer));



/***/ }),

/***/ "./sources/CustomLayers/CATableLayer.ts":
/*!**********************************************!*\
  !*** ./sources/CustomLayers/CATableLayer.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CATableBodyLayer: () => (/* binding */ CATableBodyLayer),
/* harmony export */   CATableCellLayer: () => (/* binding */ CATableCellLayer),
/* harmony export */   CATableElementLayer: () => (/* binding */ CATableElementLayer),
/* harmony export */   CATableHeadLayer: () => (/* binding */ CATableHeadLayer),
/* harmony export */   CATableHeaderLayer: () => (/* binding */ CATableHeaderLayer),
/* harmony export */   CATableLayer: () => (/* binding */ CATableLayer),
/* harmony export */   CATableRowLayer: () => (/* binding */ CATableRowLayer)
/* harmony export */ });
/* harmony import */ var uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! uikit */ "uikit");
/* harmony import */ var uikit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(uikit__WEBPACK_IMPORTED_MODULE_0__);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var CATableElementLayer = /** @class */ (function (_super) {
    __extends(CATableElementLayer, _super);
    function CATableElementLayer(contents, tag) {
        if (tag === void 0) { tag = null; }
        var _this = this;
        var element = null;
        var c = contents;
        if (contents != null) {
            element = (0,uikit__WEBPACK_IMPORTED_MODULE_0__._UICoreLayerGetFirstElementWithTag)(contents, tag);
        }
        if (element == null) {
            element = document.createElement(tag);
            if (contents != null)
                contents.appendChild(element);
            else
                c = element;
        }
        _this = _super.call(this, c) || this;
        _this.element = element;
        return _this;
    }
    return CATableElementLayer;
}(uikit__WEBPACK_IMPORTED_MODULE_0__.CALayer));

var CATableLayer = /** @class */ (function (_super) {
    __extends(CATableLayer, _super);
    function CATableLayer(contents, tag) {
        if (tag === void 0) { tag = "TABLE"; }
        return _super.call(this, contents, tag) || this;
    }
    return CATableLayer;
}(CATableElementLayer));

var CATableHeadLayer = /** @class */ (function (_super) {
    __extends(CATableHeadLayer, _super);
    function CATableHeadLayer(contents, tag) {
        if (tag === void 0) { tag = "THEAD"; }
        return _super.call(this, contents, tag) || this;
    }
    return CATableHeadLayer;
}(CATableElementLayer));

var CATableHeaderLayer = /** @class */ (function (_super) {
    __extends(CATableHeaderLayer, _super);
    function CATableHeaderLayer(contents, tag) {
        if (tag === void 0) { tag = "TH"; }
        return _super.call(this, contents, tag) || this;
    }
    Object.defineProperty(CATableHeaderLayer.prototype, "value", {
        set: function (value) {
            this.element.innerHTML = value !== null && value !== void 0 ? value : "";
        },
        enumerable: false,
        configurable: true
    });
    return CATableHeaderLayer;
}(CATableElementLayer));

var CATableRowLayer = /** @class */ (function (_super) {
    __extends(CATableRowLayer, _super);
    function CATableRowLayer(contents, tag) {
        if (tag === void 0) { tag = "TR"; }
        return _super.call(this, contents, tag) || this;
    }
    return CATableRowLayer;
}(CATableElementLayer));

var CATableBodyLayer = /** @class */ (function (_super) {
    __extends(CATableBodyLayer, _super);
    function CATableBodyLayer(contents, tag) {
        if (tag === void 0) { tag = "TBODY"; }
        return _super.call(this, contents, tag) || this;
    }
    return CATableBodyLayer;
}(CATableElementLayer));

var CATableCellLayer = /** @class */ (function (_super) {
    __extends(CATableCellLayer, _super);
    function CATableCellLayer(contents, tag) {
        if (tag === void 0) { tag = "TD"; }
        return _super.call(this, contents, tag) || this;
    }
    Object.defineProperty(CATableCellLayer.prototype, "value", {
        set: function (value) {
            this.element.innerHTML = value;
        },
        enumerable: false,
        configurable: true
    });
    return CATableCellLayer;
}(CATableElementLayer));



/***/ }),

/***/ "./sources/MUICalendarView.ts":
/*!************************************!*\
  !*** ./sources/MUICalendarView.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MUIDatePicker: () => (/* binding */ MUIDatePicker)
/* harmony export */ });
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! foundation */ "foundation");
/* harmony import */ var foundation__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(foundation__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var uikit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! uikit */ "uikit");
/* harmony import */ var uikit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(uikit__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _MUIComboBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./MUIComboBox */ "./sources/MUIComboBox.ts");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! mio-core */ "mio-core");
/* harmony import */ var mio_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(mio_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CustomLayers_CATableLayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CustomLayers/CATableLayer */ "./sources/CustomLayers/CATableLayer.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var MUIDatePicker = /** @class */ (function (_super) {
    __extends(MUIDatePicker, _super);
    function MUIDatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.delegate = null;
        _this.header = null;
        _this.daysView = null;
        _this.selectedMonth = null;
        _this.selectedYear = null;
        _this._date = null;
        return _this;
    }
    MUIDatePicker.prototype.initWithCoder = function (coder) {
        _super.prototype.initWithCoder.call(this, coder);
        this._setup();
    };
    MUIDatePicker.prototype._setup = function () {
        this.layer.addStyle("calendar-view");
        if (this.header == null) {
            this.header = new MUIDatePickerHeader();
            this.header.initWithDelegate(this);
            this.addSubview(this.header);
        }
        if (this.daysView == null) {
            this.daysView = new MUICalendarDaysView();
            this.daysView.initWithDelegate(this);
            this.addSubview(this.daysView);
        }
        var today = (0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateToday)();
        this.selectedMonth = (0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateGetMonthFromDate)(today);
        this.selectedYear = (0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateGetYearFromDate)(today);
    };
    Object.defineProperty(MUIDatePicker.prototype, "date", {
        get: function () { return this._date; },
        set: function (date) { this.setDate(date, true); },
        enumerable: false,
        configurable: true
    });
    MUIDatePicker.prototype.setDate = function (date, animated) {
        this._date = date;
        this.selectedMonth = (0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateGetMonthFromDate)(date);
        this.selectedYear = (0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateGetYearFromDate)(date);
        this.header.setMonth(this.selectedMonth);
        this.header.setYear(this.selectedYear);
        this.daysView.setMonthAndYear(this.selectedMonth, this.selectedYear);
    };
    // Calendar header delegate
    MUIDatePicker.prototype.monthAndYearDidChange = function (month, year) {
        this.selectedMonth = month;
        this.selectedYear = year;
        this.daysView.setMonthAndYear(month, year);
    };
    MUIDatePicker.prototype.didSelectDate = function (date) {
        this._date = date;
        this.sendActions(uikit__WEBPACK_IMPORTED_MODULE_1__.UIControl.Event.valueChanged);
    };
    MUIDatePicker.prototype.selectDate = function (date) {
        this.selectedMonth = (0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateGetMonthFromDate)(date);
        this.selectedYear = (0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateGetYearFromDate)(date);
        this.daysView.selectDate(date);
    };
    MUIDatePicker.prototype.resetSelection = function () {
        this.selectedMonth = null;
        this.selectedYear = null;
        this.daysView.resetSelection();
    };
    MUIDatePicker.prototype.reloadData = function () {
        this.daysView.setupDaysLayer();
    };
    return MUIDatePicker;
}(uikit__WEBPACK_IMPORTED_MODULE_1__.UIControl));

var MUIDatePickerHeader = /** @class */ (function (_super) {
    __extends(MUIDatePickerHeader, _super);
    function MUIDatePickerHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.delegate = null;
        _this.prevButton = null;
        _this.nextButton = null;
        _this.monthComboBox = null;
        _this.yearComboBox = null;
        return _this;
    }
    MUIDatePickerHeader.prototype.initWithCoder = function (coder) {
        _super.prototype.initWithCoder.call(this, coder);
        this._setup();
    };
    MUIDatePickerHeader.prototype.initWithDelegate = function (delegate) {
        _super.prototype.init.call(this);
        this.delegate = delegate;
        this._setup();
    };
    MUIDatePickerHeader.prototype._setup = function () {
        this.layer.addStyle("calendar-header");
        this.navBar = new uikit__WEBPACK_IMPORTED_MODULE_1__.UIView();
        this.navBar.init();
        this.navBar.layer.addStyle("view");
        this.navBar.layer.addStyle("calendar-nav");
        this.addSubview(this.navBar);
        if (this.prevButton == null) {
            this.prevButton = new uikit__WEBPACK_IMPORTED_MODULE_1__.UIButton();
            this.prevButton.init();
            this.prevButton.layer.addStyle("back");
            this.prevButton.layer.addStyle("calendar-prev-btn");
            this.navBar.addSubview(this.prevButton);
        }
        this.prevButton.addTarget(this, this.prev_month_action, uikit__WEBPACK_IMPORTED_MODULE_1__.UIControl.Event.touchUpInside);
        if (this.monthComboBox == null) {
            this.monthComboBox = new _MUIComboBox__WEBPACK_IMPORTED_MODULE_2__.MUIComboBox();
            this.monthComboBox.init();
            this.monthComboBox.layer.addStyle("input-combobox");
            this.navBar.addSubview(this.monthComboBox);
        }
        // Add months
        this.monthComboBox.removeAllItems();
        for (var index = 0; index < 12; index++) {
            var name_1 = (0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateGetStringForMonth)(index);
            this.monthComboBox.addItem((0,foundation__WEBPACK_IMPORTED_MODULE_0__.NSLocalizeString)(name_1, name_1), index);
        }
        this.monthComboBox.addTarget(this, this.date_did_change, uikit__WEBPACK_IMPORTED_MODULE_1__.UIControl.Event.valueChanged);
        if (this.yearComboBox == null) {
            this.yearComboBox = new _MUIComboBox__WEBPACK_IMPORTED_MODULE_2__.MUIComboBox();
            this.yearComboBox.init();
            this.yearComboBox.layer.addStyle("input-combobox");
            this.navBar.addSubview(this.yearComboBox);
        }
        // Add years
        this.yearComboBox.removeAllItems();
        // Get 10 years, 5 years before, 5 year after the selected year
        var year = (0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateGetYearFromDate)((0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateToday)());
        var minYear = year - 5;
        var maxYear = year + 5;
        for (var index = minYear; index < maxYear; index++) {
            this.yearComboBox.addItem(String(index));
        }
        this.yearComboBox.addTarget(this, this.date_did_change, uikit__WEBPACK_IMPORTED_MODULE_1__.UIControl.Event.valueChanged);
        if (this.nextButton == null) {
            this.nextButton = new uikit__WEBPACK_IMPORTED_MODULE_1__.UIButton();
            this.nextButton.init();
            this.nextButton.layer.addStyle("next");
            this.nextButton.layer.addStyle("calendar-next-btn");
            this.navBar.addSubview(this.nextButton);
        }
        this.nextButton.addTarget(this, this.next_month_action, uikit__WEBPACK_IMPORTED_MODULE_1__.UIControl.Event.touchUpInside);
    };
    MUIDatePickerHeader.prototype.prev_month_action = function (control) {
        this.addDateOffset(-1);
    };
    MUIDatePickerHeader.prototype.next_month_action = function (control) {
        this.addDateOffset(1);
    };
    MUIDatePickerHeader.prototype.date_did_change = function () {
        var m = parseInt(this.monthComboBox.selectedItem);
        var y = parseInt(this.yearComboBox.selectedItem);
        this.delegate.monthAndYearDidChange(m, y);
    };
    MUIDatePickerHeader.prototype.setMonth = function (month) {
        this.monthComboBox.selectItem(month);
    };
    MUIDatePickerHeader.prototype.setYear = function (year) {
        this.yearComboBox.selectItem(year);
    };
    MUIDatePickerHeader.prototype.addDateOffset = function (offset) {
        var m = parseInt(this.monthComboBox.selectedItem);
        var y = parseInt(this.yearComboBox.selectedItem);
        m += offset;
        if (m < 0) {
            m = 11;
            y--;
        }
        else if (m > 11) {
            m = 0;
            y++;
        }
        this.monthComboBox.selectItem(m);
        this.yearComboBox.selectItem(y);
        this.delegate.monthAndYearDidChange(m, y);
    };
    return MUIDatePickerHeader;
}(uikit__WEBPACK_IMPORTED_MODULE_1__.UIView));
var MUICalendarDaysView = /** @class */ (function (_super) {
    __extends(MUICalendarDaysView, _super);
    function MUICalendarDaysView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._month = null;
        _this._year = null;
        _this.firstDate = null;
        _this.lastDate = null;
        _this.cellSpacingX = 0;
        _this.cellSpacingY = 0;
        _this.delegate = null;
        _this.tableLayer = null;
        _this.cellsByDate = {};
        _this.bodyLayer = null;
        _this.lastSelectedCell = null;
        _this.selectedDate = null;
        return _this;
    }
    Object.defineProperty(MUICalendarDaysView.prototype, "month", {
        get: function () {
            return this._month;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MUICalendarDaysView.prototype, "year", {
        get: function () {
            return this._year;
        },
        enumerable: false,
        configurable: true
    });
    MUICalendarDaysView.prototype.initWithDelegate = function (delegate) {
        _super.prototype.init.call(this);
        this.delegate = delegate;
        this.layer.addStyle("ui-calendar-body");
        this.setupHeaderLayer();
    };
    MUICalendarDaysView.prototype.setMonthAndYear = function (month, year) {
        if (month < 0) {
            this._month = 11;
            this._year = year - 1;
        }
        else if (month > 11) {
            this._month = 0;
            this._year = year + 1;
        }
        else {
            this._month = month;
            this._year = year;
        }
        this.setupDaysLayer();
    };
    MUICalendarDaysView.prototype.setupHeaderLayer = function () {
        if (this.tableLayer == null) {
            this.tableLayer = new _CustomLayers_CATableLayer__WEBPACK_IMPORTED_MODULE_4__.CATableLayer();
            this.tableLayer.addStyle("calendar-days-view");
            this.layer.addSublayer(this.tableLayer);
        }
        // Setup Header (Days of the week)
        var dayTitle = ["SU", "MO", "TU", "WE", "TH", "FR", "SA", "SU", "MO", "TU", "WE", "TH", "FR", "SA"];
        var firstDay = foundation__WEBPACK_IMPORTED_MODULE_0__.Locale.currentLocale().firstWeekday();
        var header = new _CustomLayers_CATableLayer__WEBPACK_IMPORTED_MODULE_4__.CATableHeadLayer();
        this.tableLayer.addSublayer(header);
        var row = new _CustomLayers_CATableLayer__WEBPACK_IMPORTED_MODULE_4__.CATableRowLayer();
        header.addSublayer(row);
        for (var index = 0; index < 7; index++) {
            var dayLayer = new _CustomLayers_CATableLayer__WEBPACK_IMPORTED_MODULE_4__.CATableHeaderLayer();
            var dayTitleIndex = index + firstDay;
            dayLayer.value = (0,foundation__WEBPACK_IMPORTED_MODULE_0__.NSLocalizeString)(dayTitle[dayTitleIndex], dayTitle[dayTitleIndex]);
            row.addSublayer(dayLayer);
        }
    };
    MUICalendarDaysView.prototype.setupDaysLayer = function () {
        this.firstDate = new Date(this._year, this._month, 1);
        this.lastDate = new Date(this._year, this._month + 1, 0);
        var currentDate = new Date(this._year, this._month, 1);
        var calendar = foundation__WEBPACK_IMPORTED_MODULE_0__.Locale.currentLocale().calendar;
        var startIndex = calendar.componentFromDate(foundation__WEBPACK_IMPORTED_MODULE_0__.CalendarUnit.weekday, currentDate);
        this.cellsByDate = {};
        if (this.bodyLayer != null)
            this.bodyLayer.removeFromSuperlayer();
        this.bodyLayer = new _CustomLayers_CATableLayer__WEBPACK_IMPORTED_MODULE_4__.CATableBodyLayer();
        this.tableLayer.addSublayer(this.bodyLayer);
        var row = new _CustomLayers_CATableLayer__WEBPACK_IMPORTED_MODULE_4__.CATableRowLayer();
        this.bodyLayer.addSublayer(row);
        for (var colIndex = 0; colIndex < startIndex; colIndex++) {
            var cell = new _CustomLayers_CATableLayer__WEBPACK_IMPORTED_MODULE_4__.CATableCellLayer();
            cell.addStyle("empty-cell");
            row.addSublayer(cell);
        }
        var lastColIndex = 0;
        var lastRow = null;
        for (var rowIndex = 0; currentDate <= this.lastDate && rowIndex < 6; rowIndex++) {
            if (row == null) {
                row = new _CustomLayers_CATableLayer__WEBPACK_IMPORTED_MODULE_4__.CATableRowLayer();
                this.bodyLayer.addSublayer(row);
            }
            for (var colIndex = startIndex; colIndex < 7; colIndex++) {
                // Add day cell
                var cellLayer = new CADatePickerCellLayer();
                row.addSublayer(cellLayer);
                cellLayer.addStyle("day-cell");
                cellLayer.addStyle("day-" + currentDate.getDay());
                cellLayer.date = currentDate;
                this.cellsByDate[(0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateGetDateString)(currentDate)] = cellLayer;
                if (this.selectedDate == currentDate)
                    cellLayer.selected = true;
                var canSelect = true;
                if (this.delegate != null && this.delegate.delegate != null && typeof this.delegate.delegate.canSelectDate === "function") {
                    canSelect = this.delegate.delegate.canSelectDate.call(this.delegate.delegate, this, currentDate);
                }
                if (canSelect) {
                    cellLayer.setEnableBlock(canSelect, this, this.didSelectedCell);
                    cellLayer.addStyle("disabled");
                }
                currentDate.setDate(currentDate.getDate() + 1);
                lastColIndex = colIndex;
                if (currentDate > this.lastDate)
                    break;
            }
            startIndex = 0;
            lastRow = row;
            row = null;
        }
        // Fill last column with empty cells
        for (var colIndex = lastColIndex + 1; colIndex < 7; colIndex++) {
            var cell = new _CustomLayers_CATableLayer__WEBPACK_IMPORTED_MODULE_4__.CATableCellLayer();
            cell.addStyle("empty-cell");
            lastRow.addSublayer(cell);
        }
    };
    MUICalendarDaysView.prototype.didSelectedCell = function (cell) {
        if (this.lastSelectedCell == cell)
            return;
        if (this.lastSelectedCell != null)
            this.lastSelectedCell.selected = false;
        this.selectedDate = cell.date;
        this.lastSelectedCell = cell;
        this.delegate.didSelectDate(cell.date);
    };
    MUICalendarDaysView.prototype.selectDate = function (date) {
        var d = (0,mio_core__WEBPACK_IMPORTED_MODULE_3__.MCDateGetDateString)(date);
        this.selectedDate = date;
        var cell = this.cellsByDate[d];
        if (cell == this.lastSelectedCell)
            return;
        if (this.lastSelectedCell != null)
            this.lastSelectedCell.selected = false;
        if (cell != null) {
            this.lastSelectedCell = cell;
            cell.selected = true;
        }
    };
    MUICalendarDaysView.prototype.resetSelection = function () {
        if (this.lastSelectedCell != null)
            this.lastSelectedCell.selected = false;
    };
    return MUICalendarDaysView;
}(uikit__WEBPACK_IMPORTED_MODULE_1__.UIView));
var CADatePickerCellLayer = /** @class */ (function (_super) {
    __extends(CADatePickerCellLayer, _super);
    function CADatePickerCellLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._date = null;
        _this._day = null;
        _this._month = null;
        _this._year = null;
        _this._isToday = false;
        _this._on_click_target = null;
        _this._on_click_action = null;
        return _this;
    }
    Object.defineProperty(CADatePickerCellLayer.prototype, "date", {
        get: function () {
            return this._date;
        },
        set: function (date) {
            this._date = new Date(date.getTime());
            this._day = date.getDate();
            this._month = date.getMonth();
            this._year = date.getFullYear();
            var today = new Date();
            var d = today.getDate();
            var m = today.getMonth();
            var y = today.getFullYear();
            this.value = date.getDate().toString();
            this._isToday = (this._day == d && this._month == m && this._year == y);
            if (this._isToday)
                this.addStyle("today");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CADatePickerCellLayer.prototype, "isToday", {
        get: function () { return this._isToday; },
        enumerable: false,
        configurable: true
    });
    CADatePickerCellLayer.prototype.setEnableBlock = function (value, target, action) {
        if (value == true) {
            this._on_click_target = target;
            this._on_click_action = action;
            this.registerEventAction(this, this.on_click_event);
        }
        else {
            this._on_click_target = null;
            this._on_click_action = null;
            this.addStyle("disabled");
        }
    };
    CADatePickerCellLayer.prototype.on_click_event = function (event) {
        if (event != uikit__WEBPACK_IMPORTED_MODULE_1__.CALayerEvent.mouseUp)
            return;
        this.selected = true;
        if (this._on_click_action != null)
            this._on_click_action.call(this._on_click_target, this);
    };
    Object.defineProperty(CADatePickerCellLayer.prototype, "selected", {
        set: function (value) {
            if (value == true)
                this.addStyle("selected");
            else
                this.removeStyle("selected");
        },
        enumerable: false,
        configurable: true
    });
    return CADatePickerCellLayer;
}(_CustomLayers_CATableLayer__WEBPACK_IMPORTED_MODULE_4__.CATableCellLayer));


/***/ }),

/***/ "./sources/MUIComboBox.ts":
/*!********************************!*\
  !*** ./sources/MUIComboBox.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MUIComboBox: () => (/* binding */ MUIComboBox)
/* harmony export */ });
/* harmony import */ var uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! uikit */ "uikit");
/* harmony import */ var uikit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(uikit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CustomLayers_CAComboBoxLayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CustomLayers/CAComboBoxLayer */ "./sources/CustomLayers/CAComboBoxLayer.ts");
/* harmony import */ var _CustomLayers_CAComboBoxItemLayer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CustomLayers/CAComboBoxItemLayer */ "./sources/CustomLayers/CAComboBoxItemLayer.ts");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MUIComboBox = /** @class */ (function (_super) {
    __extends(MUIComboBox, _super);
    function MUIComboBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._selectedItem = -1;
        return _this;
        // getItemAtIndex(index)
        // {
        //     if (this._selectLayer.childNodes.length == 0)
        //         return null;
        //     var option = this._selectLayer.childNodes[index];
        //     return option.innerHTML;
        // }
        // getSelectedItemText()
        // {
        //     for (var index = 0; index < this._selectLayer.childNodes.length; index++)
        //     {
        //         var option = this._selectLayer.childNodes[index];
        //         if (this._selectLayer.value == option.value)
        //             return option.innerHTML;
        //     }
        // }
        // protected on_event( event:any ) {
        //     super.on_event( event );
        //     if (event == CALayerEvent.change) {
        //         this.sendActions( UIControl.Event.valueChanged );
        //     }
        // }
    }
    Object.defineProperty(MUIComboBox, "layerClass", {
        get: function () { return _CustomLayers_CAComboBoxLayer__WEBPACK_IMPORTED_MODULE_1__.CAComboBoxLayer; },
        enumerable: false,
        configurable: true
    });
    MUIComboBox.prototype.init = function () {
        _super.prototype.init.call(this);
        this.layer.setOnChangeBlock(this, this._on_change);
    };
    MUIComboBox.prototype.initWithCoder = function (coder) {
        _super.prototype.initWithCoder.call(this, coder);
        this.layer.setOnChangeBlock(this, this._on_change);
    };
    MUIComboBox.prototype.addItem = function (title, value) {
        var item = new _CustomLayers_CAComboBoxItemLayer__WEBPACK_IMPORTED_MODULE_2__.CAComboBoxItemLayer();
        item.setValue(title, value);
        this.layer.addItemLayer(item);
    };
    MUIComboBox.prototype.selectItem = function (value) {
        this.layer.selectItem(value);
    };
    Object.defineProperty(MUIComboBox.prototype, "selectedItem", {
        get: function () {
            return this.layer.selectedItem;
        },
        enumerable: false,
        configurable: true
    });
    MUIComboBox.prototype._on_change = function () {
        this.sendActions(uikit__WEBPACK_IMPORTED_MODULE_0__.UIControl.Event.valueChanged);
    };
    // addItems(items)
    // {
    //     for (var count = 0; count < items.length; count++)
    //     {
    //         var text = items[count];
    //         this.addItem(text);
    //     }
    // }
    MUIComboBox.prototype.removeAllItems = function () {
        this.layer.removeItemLayers();
    };
    return MUIComboBox;
}(uikit__WEBPACK_IMPORTED_MODULE_0__.UIControl));



/***/ }),

/***/ "foundation":
/*!*****************************!*\
  !*** external "foundation" ***!
  \*****************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_foundation__;

/***/ }),

/***/ "mio-core":
/*!***************************!*\
  !*** external "mio-core" ***!
  \***************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_mio_core__;

/***/ }),

/***/ "uikit":
/*!************************!*\
  !*** external "uikit" ***!
  \************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_uikit__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!***************************!*\
  !*** ./sources/_index.ts ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MUIComboBox: () => (/* reexport safe */ _MUIComboBox__WEBPACK_IMPORTED_MODULE_0__.MUIComboBox),
/* harmony export */   MUIDatePicker: () => (/* reexport safe */ _MUICalendarView__WEBPACK_IMPORTED_MODULE_1__.MUIDatePicker)
/* harmony export */ });
/* harmony import */ var _MUIComboBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./MUIComboBox */ "./sources/MUIComboBox.ts");
/* harmony import */ var _MUICalendarView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./MUICalendarView */ "./sources/MUICalendarView.ts");



})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=muikit.js.map